import { isNullOrUndefined } from './utils';

/**
 * Transforms a given object by recursively applying the given transformation function
 * on all the objects inside and including the initial object
 *
 * @param obj The object to transform
 * @param transformFn Transformation function to apply on all the objectds
 * @returns The transformed object.
 */
export default function recursiveObjectTransform(
  obj: unknown,
  transformFn: (source: Record<string, unknown>) => Record<string, unknown>
): unknown {
  if (typeof obj !== 'object' || isNullOrUndefined(obj)) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(el => recursiveObjectTransform(el, transformFn));
  }

  const result = Object.getOwnPropertyNames(obj).reduce(
    (prev, key) => ({ ...prev, [key]: recursiveObjectTransform(obj[key], transformFn) }),
    {}
  );

  return transformFn(result);
}
